import config from '@/config/config';

export default {
  isLoggedIn: ({ user = {} }) => {
    return user.token !== null;
  },
  fullName: ({ user = {} }) => {
    return `${user.firstName} ${user.lastName}`;
  },
  register: ({ user = {} }) => ({
    invitationCode: user.invitationCode,
    user: {
      firstName: user.firstName || null,
      lastName: user.lastName || null,
      email: user.email || null,
      plainPassword: user.password || null,
    },
  }),
  user: (state) => {
    const user = Object.assign({}, state.user);

    Object.keys(user).map (key => {
      if (user[key] === null) {
        delete user[key];
      }
    });

    if (user.password) {
      user.plainPassword = user.password;
      delete user.password;
    }

    return user;
  },
  courseComponent: (state) => {
    switch (state.currentCourse) {
      case config.initial.course.lecture:
        return 'Lecture';
      case config.initial.course.video:
        return 'Video';
      case config.initial.course.materials:
        return 'Materials';
      case config.initial.course.finish:
        return 'Finish';
      case config.initial.course.start:
      default:
        return 'Info';
    }
  },
};
